import React from "react";
import type { Direction } from "../types.ts";

interface GameControlsProps {
  moveCount: number;
  maxMoves: number;
  optimalMoves: number;
  canUndo: boolean;
  disabled: boolean;
  onMove: (dir: Direction) => void;
  onUndo: () => void;
  onReset: () => void;
}

export function GameControls({
  moveCount,
  maxMoves,
  optimalMoves,
  canUndo,
  disabled,
  onMove,
  onUndo,
  onReset,
}: GameControlsProps) {
  return (
    <div className="flex flex-col items-center gap-4">
      {/* D-pad */}
      <div className="grid grid-cols-3 gap-1 w-36">
        <div />
        <DPadButton dir="up" label={"↑"} disabled={disabled} onMove={onMove} />
        <div />
        <DPadButton dir="left" label={"←"} disabled={disabled} onMove={onMove} />
        <div className="w-11 h-11" />
        <DPadButton dir="right" label={"→"} disabled={disabled} onMove={onMove} />
        <div />
        <DPadButton dir="down" label={"↓"} disabled={disabled} onMove={onMove} />
        <div />
      </div>

      {/* Actions + counter */}
      <div className="flex items-center gap-4">
        <button
          onClick={onUndo}
          disabled={!canUndo}
          className="px-4 py-2 bg-slate-800 hover:bg-slate-700 disabled:opacity-40 disabled:cursor-not-allowed rounded-lg text-sm font-medium transition-colors border border-slate-600"
        >
          Undo
        </button>
        <button
          onClick={onReset}
          className="px-4 py-2 bg-slate-800 hover:bg-slate-700 rounded-lg text-sm font-medium transition-colors border border-slate-600"
        >
          Reset
        </button>
        <div className="text-sm text-slate-400">
          <span className="text-white font-mono">{moveCount}</span>
          {" / "}
          <span className="font-mono">{maxMoves}</span>
          {" moves"}
          <span className="ml-2 text-slate-600">(par: {optimalMoves})</span>
        </div>
      </div>
    </div>
  );
}

function DPadButton({
  dir,
  label,
  disabled,
  onMove,
}: {
  dir: Direction;
  label: string;
  disabled: boolean;
  onMove: (dir: Direction) => void;
}) {
  return (
    <button
      onClick={() => onMove(dir)}
      disabled={disabled}
      className="w-11 h-11 flex items-center justify-center bg-slate-800 hover:bg-slate-700 disabled:opacity-40 disabled:cursor-not-allowed rounded-lg text-lg font-bold transition-colors border border-slate-600 select-none"
    >
      {label}
    </button>
  );
}
